import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["realInput", "popover", "trigger"];

  connect() {
    window.addEventListener(
      "click",
      (this._outsideClickHandler = this.close.bind(this)),
    );
  }

  disconnect() {
    window.removeEventListener("click", this._outsideClickHandler);
  }

  show(e) {
    e.stopPropagation();
    this.popoverTarget.classList.remove("hidden");
    this.triggerTarget.classList.add("hidden");

    // Block background scroll on mobile when full-screen popover is open
    if (this.#isFullScreenPopover()) {
      document.body.classList.add("no-scroll");
    }
  }

  hide(e) {
    e.stopPropagation(e);

    this.close(e, true);
  }

  close(event, force = false) {
    if (this.popoverTarget.classList.contains("hidden")) return;

    if (this.popoverTarget.contains(event.target) && !force) return;

    // Don't close if clicking within a nested CHILD popover controller
    const nestedPopoverController = event.target.closest(
      '[data-controller*="popover"]',
    );
    if (
      nestedPopoverController &&
      nestedPopoverController !== this.element &&
      this.element.contains(nestedPopoverController) && // ← Check it's a child, not a parent
      !force
    )
      return;

    this.popoverTarget.classList.add("hidden");
    this.triggerTarget.classList.remove("hidden");

    // Restore background scroll when full-screen popover closes
    if (this.#isFullScreenPopover()) {
      document.body.classList.remove("no-scroll");
    }
  }

  #isFullScreenPopover() {
    return this.popoverTarget.classList.contains("full-screen-popover");
  }
}
